import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ContactManagementService {

    public apiUrl: any;
    constructor(private http: HttpClient) {
        this.apiUrl = window['__env'].apiUrl;
    }

    getContactDetails(requestObj: any, viewFlag: any, validationStatus: any) {
        return this.http.post(`${this.apiUrl}/contactService/viewAllContacts?viewFlag=${viewFlag}&status=${encodeURIComponent(validationStatus.toUpperCase())}`, requestObj);
    }

    getAllContactsForDownload(requestObj: any) {
        return this.http.post(
            `${this.apiUrl}/contactService/viewAllContacts?viewFlag=A&status=ALL`,
            requestObj
        );
    }

    getPamDetails(supplierName: any) {
        return this.http.get(`${this.apiUrl}/contactService/fetchPamIds?supplierName=${encodeURIComponent(supplierName)}`);
    }

    createUpdateContact(requestObject: any, viewType: any, userType: any, cecIdRole: any) {
        return this.http.post(`${this.apiUrl}/contactService/createUpdateContact?viewType=${viewType}&userType=${userType}&cecIdRole=${cecIdRole}`,
            requestObject);
    }

    deleteContact(viewType: any, flag: any, requestObject: any) {
        return this.http.post(`${this.apiUrl}/contactService/deleteContact?viewType=${viewType}&flag=${flag}`, requestObject);
    }

    restoreContact(contactId: any) {
        return this.http.post(`${this.apiUrl}/contactService/restoreContact?contactId=${contactId}`, {});
    }

    checkInternalContact() {
        return this.http.post(`${this.apiUrl}/contactService/checkInternalContact`, {});
    }

    uploadContactsExcel(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/uploadBulkContact`, requestObj);
    }

    fetchSavedContactAttr(supp_name: any, viewType: any) {
        return this.http.get(`${this.apiUrl}/contactService/fetchSavedContactFields?supplierName=${encodeURIComponent(supp_name)}&viewType=${viewType}`)
    }

    saveContactGridAttr(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/saveContactFields`, requestObj)
    }

    downloadAttachments() {
        return this.http.get(`${this.apiUrl}/contactService/download/ContactMgmUploadData.xlsx`, {
            responseType: "blob",
            headers: new HttpHeaders().append("Content-Type", "application/json")
        });
    }

    getSupplierContacts(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/fetchSupplierContactFields`, requestObj);
    }

    filterContacts(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/fetchContactDetailsViaFilter`, requestObj);
    }

    getExecutiveContactsForValidation(status: any, month: any) {
        let url = month ? `${this.apiUrl}/contactService/executiveContacts?status=${status}&months=${month}` : `${this.apiUrl}/contactService/executiveContacts?status=${status}`;
        return this.http.get(`${url}`);
    }

    updateStatusOfExecutiveContacts(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/executiveContacts/update`, requestObj);
    }

    deleteExecutiveContact(contactId: any) {
        return this.http.delete(`${this.apiUrl}/contactService/executiveContacts/delete?contactId=${contactId}`);
    }

    getExecutiveSupplierContacts(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/executive-contacts/upload`, requestObj);
    }
    getSucmDirectorData() {
        return this.http.get(`${this.apiUrl}/contactService/executive-contacts/validation-popup`);
    }

    createExecutiveContactValidation(requestObj: any, options?: any) {
        return this.http.post(`${this.apiUrl}/contactService/executive-contacts/create-validation`, requestObj, options);
    }
    updateDateInprogress(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/executive-contacts/update-validation-dates`, requestObj);
    }
    getInprogressData(status: any) {
        return this.http.get(`${this.apiUrl}/contactService/executive-contacts/validation-details?status=${status}`);
    }
    createExecutiveContactChild(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/executiveContacts/create`, requestObj);
    }
    executiveContactReminderPopUp(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/executive-contacts/validation-reminder`, requestObj);
    }
    getValidationLogData() {
        return this.http.get(`${this.apiUrl}/contactService/executive-contacts/validation-logs`);
    }

    getSupplierListForLoggedInSucm() {
        return this.http.get(`${this.apiUrl}/contactService/suppliers`);
    }

    saveNewContactDomain(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/supplier-domain`, requestObj);
    }

    getSupplierDomains(supplierName: any) {
        return this.http.get(`${this.apiUrl}/contactService/domains?supplier=${encodeURIComponent(supplierName)}`);
    }
    deleteExecutiveContacts(requestObj: any) {
        return this.http.delete(
            `${this.apiUrl}/contactService/executive-contacts/validation-details/suppliers`,
            { body: requestObj }
        );
    }

    downloadExecutiveContactAttachments() {
        return this.http.get(`${this.apiUrl}/contactService/download/bulk-executive-contacts-template`, {
            responseType: "blob",
            headers: new HttpHeaders().append("Content-Type", "application/json")
        });
    }

    uploadExecutiveContactsExcel(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/upload-bulk-executive-contacts`, requestObj);
    }

    downloadExecutiveContactsErrorReport(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/download/failed-upload-executive-contacts`, requestObj, {
            responseType: "blob",
            headers: new HttpHeaders().append("Content-Type", "application/json")
        });
    }

    getContactsByDomain(supplierName: any, domainName: any) {
        return this.http.get(`${this.apiUrl}/contactService/contacts/by-supplier-and-domain?supplierName=${encodeURIComponent(supplierName)}&domainName=${encodeURIComponent(domainName)}`);
    }

    deleteDomain(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/contacts/delete-domains`, requestObj);
    }

    updateContactData(requestObj: any) {
        return this.http.put(`${this.apiUrl}/contactService/executive-contacts/update-record`, requestObj);
    }

    updateValidationStatus(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/viewAllContacts/updateValidationStatus`, requestObj);
    }

    validateSupplierContacts(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/supplierContacts/validateContactStatus`, requestObj);
    }

    enableSubscribeToComm(requestObj: any) {
        return this.http.post(`${this.apiUrl}/contactService/viewAllContacts/subscribeToComms`, requestObj);
    }
}

